
import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Input } from 'reactstrap';
import * as XLSX from 'xlsx';
import { v4 as uuidv4 } from 'uuid';
import DayPicker from 'react-day-picker';

import './CustomDayConfig.scss';
import { fetchGetParkingDayConfig, fetchCreateParkingDayConfig, fetchUpdateParkingDayConfig, fetchGetBuildingByBuildingID } from '../../actions';
import commonConstant from '../../common/_commonConstant';
import { randomNumber } from '../../common/_commonFunction';
import { 
  Table,
  validateToShowDash,
  totalParkingDayConfigRecords,
  dateYYYYMMDD,
  timeFormatHHMM,
  Modal,
  DatePicker,
  HeaderSection,
  InputWithUpload,
  dateDDMMYYYYFormat,
  Dropdown,
  validateNumber,
  history,
} from '../../helpers';
import { Loading } from '../../components';



const columnHeader = [
  { 'label': 'ลำดับที่', 'className': 'number', 'sort': false, 'key': '' },
  { 'label': 'วันที่', 'className': 'date', 'sort': false, 'key': 'date' },
  { 'label': 'Time type', 'className': 'time-type', 'sort': false, 'key': '' },
  { 'label': 'Start time', 'className': 'start-time', 'sort': false, 'key': '' },
  { 'label': 'End time', 'className': 'end-time', 'sort': false, 'key': '' },
  { 'label': 'Parking zone', 'className': 'parking-zone', 'sort': false, 'key': '' },
  { 'label': 'Allowance', 'className': 'allowance', 'sort': false, 'key': '' },
  { 'label': 'Charge customer', 'className': 'charge-customer', 'sort': false, 'key': '' },
  { 'label': '', 'className': 'view', 'sort': false, 'key': '', 'keyFuncName': 'view' },
];
class CustomDayConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'loading': false,    
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
      'fromDate':null,
      'toDate':null,
      'sort': commonConstant.defaultSortCustomParkingDayConfig,
      'showModal' : false,
      'modalType' : '',
      'selectTypeDate': 4,
      'customDayConfigData' : null,
      'parkingDayConfigId' : '',
      'date' : '',
      'timeType' : null,
      'startTime' : null,
      'endTime' : null,
      'parkingZone' : '',
      'allowance' : null,
      'chargeCustomer' : null,
      'calendarModal' : false,
    };

    this.timeType = createRef();
    this.startTime = createRef();
    this.endTime = createRef();
    this.parkingZone = createRef();
    this.allowance = createRef();
    this.chargeCustomer = createRef();

    this.passFuncBody = [
      (data, objToPassFuncBody, pageSize, pageNumber, index, condition) => !condition && ((pageSize * (pageNumber - 1)) + (index + 1)),      
      (data, objToPassFuncBody, pageSize, pageNumber, index, condition) => (dateYYYYMMDD(data.startDatetime)),
      (data, objToPassFuncBody, pageSize, pageNumber, index, condition) => (timeFormatHHMM(data.startDatetime) === '00:00' && timeFormatHHMM(data.endDatetime) === '23:59' ? commonConstant.parkingDayConfigTimeType[1].value : commonConstant.parkingDayConfigTimeType[0].value),
      (data, objToPassFuncBody, pageSize, pageNumber, index, condition) => (timeFormatHHMM(data.startDatetime)),
      (data, objToPassFuncBody, pageSize, pageNumber, index, condition) => (timeFormatHHMM(data.endDatetime)),
      (data, objToPassFuncBody, pageSize, pageNumber, index, condition) => (data.parkingZone.split('-')[2]),
      (data, objToPassFuncBody, pageSize, pageNumber, index, condition) => (data.allowance),
      (data, objToPassFuncBody, pageSize, pageNumber, index, condition) => (data.chargeCustomer),
      (data, objToPassFuncBody, pageSize, pageNumber, index, condition) => !condition && <span key={randomNumber()}>view</span>,
    ];
  }

  componentDidMount() {
    const { match } = this.props;
    const { fromDate, toDate, pageSize, sort } = this.state;
    this.setState({
      'loading': true,      
    });


    this.props.dispatch(fetchGetBuildingByBuildingID(this.props.match.params.buildingID));
    this.props.dispatch(fetchGetParkingDayConfig(
      match.params.buildingID,
      'CUSTOM',   
      fromDate ? dateYYYYMMDD(fromDate) : null,
      toDate ? dateYYYYMMDD(toDate) : null,
      0,
      pageSize.value,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
    ));
  }

  componentDidUpdate(prevProps) {
    const { getParkingDayConfig, updateParkingDayConfig, createParkingDayConfig } = this.props;

    if (getParkingDayConfig.status === 200 && getParkingDayConfig.type === commonConstant.GET_PARKING_DAY_CONFIG_SUCCESS && prevProps.getParkingDayConfig != getParkingDayConfig) {
      this.setState({
        'loading': false,
      });
    } else if (updateParkingDayConfig.status === 200 && updateParkingDayConfig.type === commonConstant.UPDATE_PARKING_DAY_CONFIG_SUCCESS && prevProps.updateParkingDayConfig != updateParkingDayConfig) {
      this.handleClearState();
      this.setState({
        'loading': false,
        'showModal' : false,
      });
    } else if (createParkingDayConfig.status === 200 && createParkingDayConfig.type === commonConstant.CREATE_PARKING_DAY_CONFIG_SUCCESS && prevProps.createParkingDayConfig != createParkingDayConfig) {
      this.handleClearState();
      this.setState({
        'loading': false,
        'showModal' : false,
      });
    } else if (updateParkingDayConfig.status === 400 || createParkingDayConfig.status === 400) {
      this.setState({
        'loading': false,
        'showModal' : false,
      });
    }
  }

  handleClearState = () => {
    const { match } = this.props;
    const { fromDate, toDate, pageSize, sort } = this.state;

    this.setState({        
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
      'fromDate':null,
      'toDate':null,
      'sort': commonConstant.defaultSortCustomParkingDayConfig,            
      'selectTypeDate': 4,      
    });

    this.props.dispatch(fetchGetParkingDayConfig(
      match.params.buildingID,
      'CUSTOM',   
      fromDate ? dateYYYYMMDD(fromDate) : null,
      toDate ? dateYYYYMMDD(toDate) : null,
      0,
      pageSize.value,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
    ));
  }

  handlePageChange = pageNumber => {
    const { fromDate, toDate, pageSize, sort } = this.state;
    const { match } = this.props;

    this.setState({ pageNumber, 'loading': true });

    return this.props.dispatch(fetchGetParkingDayConfig(
      match.params.buildingID,
      'CUSTOM',   
      fromDate ? dateYYYYMMDD(fromDate) : null,
      toDate ? dateYYYYMMDD(toDate) : null,
      (pageSize.value * pageNumber) - pageSize.value >= 0 ? (pageSize.value * pageNumber) - pageSize.value : 0,
      pageSize.value,    
      sort.key,
      sort.sort ? 'descending' : 'ascending',      
    ));
  }

  handlePageSize = pageSize => {
    const { fromDate, toDate, sort, pageNumber } = this.state;
    const { match } = this.props;

    this.setState({ pageSize, 'pageNumber': 1, 'loading': true });

    return this.props.dispatch(fetchGetParkingDayConfig(
      match.params.buildingID,
      'CUSTOM',   
      fromDate ? dateYYYYMMDD(fromDate) : null,
      toDate ? dateYYYYMMDD(toDate) : null,
      (pageSize.value * pageNumber) - pageSize.value >= 0 ? (pageSize.value * pageNumber) - pageSize.value : 0,
      pageSize.value,   
      sort.key,
      sort.sort ? 'descending' : 'ascending',      
    ));
  }

  handleHeaderModal = () => {
    const { modalType } = this.state;

    switch (modalType) {
      case 'create':
        return 'สร้าง Custom day config';
      case 'edit':
        return 'แก้ไข Custom day config';
      case 'upload':
        return 'Upload custom day config';
      default:
        break;
    }
  }

  handleEvent = (key, value) => {    
    this.setState({ [key]: value });

    if (key === 'timeType') {
      this.timeType.current.handleShowItem();
    } else if (key === 'startTime') {
      this.startTime.current.handleShowItem();
    } else if (key === 'endTime') {
      this.endTime.current.handleShowItem();
    } else if (key === 'allowance') {
      this.allowance.current.handleShowItem();
    } else if (key === 'chargeCustomer') {
      this.chargeCustomer.current.handleShowItem();
    } else if (key === 'parkingZone') {
      this.parkingZone.current.handleShowItem();
    }
  }

  handleCreateOrUpdateParkingDayConfig = () => {
    const { date, timeType, startTime, endTime, parkingZone, allowance, chargeCustomer, modalType, parkingDayConfigId } = this.state;

    this.setState({ 'loading': true });

    if (modalType === 'create') {
      this.props.dispatch(fetchCreateParkingDayConfig({
        'data' : [
          {
            'buildingID' : this.props.match.params.buildingID,
            'parkingDayConfigID' : uuidv4(),
            'dayType': 'CUSTOM',          
            'parkingZone': `IN-${parkingZone}/OUT-${parkingZone}`,
            'allowance': allowance.value,
            'chargeCustomer': chargeCustomer.value,
            'startDatetime' : `${dateYYYYMMDD(date)} ${timeType.value === 'ALL_DAY' ? '00:00:00' : `${startTime.value}:00`}`,
            'endDatetime' : `${dateYYYYMMDD(date)} ${timeType.value === 'ALL_DAY' ? '23:59:00' : `${endTime.value}:00`}`,
          },
        ],
      }));
    } else if (modalType === 'edit') {
      this.props.dispatch(fetchUpdateParkingDayConfig({
        'data' : [
          {
            'buildingID' : this.props.match.params.buildingID,
            'parkingDayConfigID' : parkingDayConfigId,
            'dayType': 'CUSTOM',          
            'parkingZone': `IN-${parkingZone}/OUT-${parkingZone}`,
            'allowance': allowance.value,
            'chargeCustomer': chargeCustomer.value,
            'startDatetime' : `${dateYYYYMMDD(date)} ${timeType.value === 'ALL_DAY' ? '00:00:00' : `${startTime.value}:00`}`,
            'endDatetime' : `${dateYYYYMMDD(date)} ${timeType.value === 'ALL_DAY' ? '23:59:00' : `${endTime.value}:00`}`,
          },
        ],
      }));
    }
  }

  handleParkingZoneDropdown = () => {
    const { getBuildingByRefNo } = this.props;
    const { parkingZone } = this.state;
    const parkingZoneInPosition = getBuildingByRefNo.data.buildingIotDevices.filter((item) => item.BuildingIotDeviceLocation === 'IN');
    parkingZoneInPosition.sort((a, b) => parseInt(a.BuildingIotDevicePosition, 10) - parseInt(b.BuildingIotDevicePosition, 10));
    return parkingZoneInPosition.map((item, index) => (
      <div
        key={index}
        className={`item${parkingZone && parkingZone === item.BuildingIotDevicePosition ? ' active' : ''}`}
        onClick={() => this.handleEvent('parkingZone', item.BuildingIotDevicePosition)}
      >{item.BuildingIotDevicePosition}</div>
    ));
  }

  handleCreteEditModalContent = () => {
    const { date, calendarModal, timeType, startTime, endTime, parkingZone, allowance, chargeCustomer } = this.state;      

    return <div className="custom-day-config-modal">
      <Modal
        show={calendarModal}
      >
        <div className="bg">
          <DayPicker
            month={new Date(new Date().setMonth(new Date().getMonth()))}
            fromMonth={new Date(new Date().getFullYear(), new Date().getMonth())}
            toMonth={new Date(new Date().getFullYear(), 11)}
            selectedDays={date}
            numberOfMonths={1}            
            onDayClick={(day) => this.handleEvent('date', day)}
            renderDay={day => <span id={`date-pickey-${dateYYYYMMDD(new Date(day))}`}>{new Date(day).getDate()}</span>}          
          />
          <div className="box-btn">                      
            <Button className="btn-sixtary close" id="btn-close-datepicker" onClick={() => this.setState({ 'calendarModal': false })}>
                          Close
            </Button>                     
          </div>
        </div>  
      </Modal>
      <HeaderSection title={'Custom day config'} isHeader={true} />
      <div>
        <div className="custom-date-picker-container">
          <div className="custom-date-picker-label">Date</div>
          <div className="custom-date-picker" onClick={() => this.setState({ 'calendarModal': true })}>
            <div>{date === '' ? 'Choose date' : `${dateDDMMYYYYFormat(date)}`}</div>
            <div className="icon icon-calendar-1"/>
          </div>
        </div>
        <div className="time-container">
          <div className="time-type-container">
            <div className="time-type-label">Time type</div>
            <div className="time-type-dropdown">
              <Dropdown
                template="b"
                placeholder="Choose time type"
                value={timeType && timeType.label ? timeType.label : null}
                ref={this.timeType} >              
                {
                  commonConstant.parkingDayConfigTimeType.map((ele, parkingTimePeriodIndex) => (
                    <div
                      key={parkingTimePeriodIndex}
                      className={`item${timeType && timeType.value === ele.value ? ' active' : ''}`}
                      onClick={() => this.handleEvent('timeType', ele)}
                    >{ele.label}</div>
                  ))
                }              
              </Dropdown>
            </div>
          </div>
          {
            timeType && timeType.value === 'CUSTOM' ? <div className="start-time-container">
              <div className="start-time-label">Start time</div>
              <div className="start-time-dropdown">
                <Dropdown
                  template="b"
                  placeholder="Choose start time"
                  value={startTime && startTime.label ? startTime.label : null}
                  ref={this.startTime} >  
                  <div className="start-time-dropdown-container">
                    {
                      commonConstant.parkingTimePeriodStart.map((ele, parkingTimePeriodIndex) => (
                        <div
                          key={parkingTimePeriodIndex}
                          className={`item${startTime && startTime.value === ele.value ? ' active' : ''}`}
                          onClick={() => this.handleEvent('startTime', ele)}
                        >{ele.label}</div>
                      ))
                    }    
                  </div>                                
                </Dropdown>
              </div>
            </div> : null
          }
          {
            timeType && timeType.value === 'CUSTOM' ? <div className="end-time-container">
              <div className="end-time-label">end time</div>
              <div className="end-time-dropdown">
                <Dropdown
                  template="b"
                  placeholder="Choose end time"
                  value={endTime && endTime.label ? endTime.label : null}
                  ref={this.endTime} >              
                  <div className="end-time-dropdown-container">
                    {
                      commonConstant.parkingTimePeriodEnd.map((ele, parkingTimePeriodIndex) => (
                        <div
                          key={parkingTimePeriodIndex}
                          className={`item${endTime && endTime.value === ele.value ? ' active' : ''}`}
                          onClick={() => this.handleEvent('endTime', ele)}
                        >{ele.label}</div>
                      ))
                    }  
                  </div>            
                </Dropdown>
              </div>
            </div> : null
          }  
        </div>
        <div className="config-container">
          <div className="parking-zone-container">
            <div className="parking-zone-label">Parking zone</div>
            <div className="parking-zone-input">
              <Dropdown
                template="b"
                placeholder="Choose parking zone"
                value={parkingZone ? parkingZone : null}
                ref={this.parkingZone} >              
                <div className="end-time-dropdown-container">
                  {
                    this.handleParkingZoneDropdown()
                  }  
                </div>            
              </Dropdown>
            </div>
          </div>
          <div className="allowance-container">
            <div className="allowance-label">Allowance</div>
            <div className="allowance-dropdown">
              <Dropdown
                template="b"
                placeholder="Choose allowance"
                value={allowance && allowance.label ? allowance.label : null}
                ref={this.allowance} >  
                <div className="allowance-dropdown-container">
                  {
                    commonConstant.parkingDayConfigMemberType.map((ele, parkingTimePeriodIndex) => (
                      <div
                        key={parkingTimePeriodIndex}
                        className={`item${allowance && allowance.value === ele.value ? ' active' : ''}`}
                        onClick={() => this.handleEvent('allowance', ele)}
                      >{ele.label}</div>
                    ))
                  }    
                </div>                                
              </Dropdown>
            </div>
          </div>
          <div className="chargeCustomer-container">
            <div className="chargeCustomer-label">Charge customer</div>
            <div className="chargeCustomer-dropdown">
              <Dropdown
                template="b"
                placeholder="Choose charge customer"
                value={chargeCustomer && chargeCustomer.label ? chargeCustomer.label : null}
                ref={this.chargeCustomer} >  
                <div className="chargeCustomer-dropdown-container">
                  {
                    commonConstant.parkingDayConfigChargeCustomerType.map((ele, index) => (
                      <div
                        key={index}
                        className={`item${chargeCustomer && chargeCustomer.value === ele.value ? ' active' : ''}`}
                        onClick={() => this.handleEvent('chargeCustomer', ele)}
                      >{ele.label}</div>
                    ))
                  }    
                </div>                                
              </Dropdown>
            </div>
          </div>
        </div>
        <div className="button-container">
          <Button onClick={() => {this.handleCreateOrUpdateParkingDayConfig();}} className="btn-primary send-data-button">ส่งข้อมูล</Button>
        </div>
      </div>
    </div>; 
  }

  handleModalContent = () => {
    const { modalType } = this.state;

    switch (modalType) {
      case 'create':        
        return this.handleCreteEditModalContent();
      case 'edit':        
        return this.handleCreteEditModalContent();
      case 'upload':
        return this.handleUploadModalContent();
      default:
        break;
    }
  }

  handleShowModal = (modalType, data) => {
    if (modalType === 'upload') {
      this.setState({
        'customDayConfigData': null,        
      });
    } else if (modalType === 'create') {
      this.setState({        
        'date' : '',
        'timeType' : null,
        'startTime' : null,
        'endTime' : null,
        'parkingZone' : '',
        'allowance' : null,
        'chargeCustomer' : null,
      });
    } else if (modalType === 'edit') {
      this.setState({        
        'date' : new Date(data.startDatetime),
        'timeType' : timeFormatHHMM(data.startDatetime) === '00:00' && timeFormatHHMM(data.endDatetime) === '23:59' ? commonConstant.parkingTimePeriodType[0] : commonConstant.parkingTimePeriodType[1],
        'startTime' : commonConstant.parkingTimePeriodStart.filter((item) => item.value === timeFormatHHMM(data.startDatetime))[0],
        'endTime' : commonConstant.parkingTimePeriodEnd.filter((item) => item.value === timeFormatHHMM(data.endDatetime))[0],
        'parkingZone' : data.parkingZone.split('-')[2],
        'allowance' : commonConstant.parkingDayConfigMemberType.filter((item) => item.value === data.allowance)[0],
        'chargeCustomer' : commonConstant.parkingDayConfigChargeCustomerType.filter((item) => item.value === data.chargeCustomer)[0],
        'parkingDayConfigId': data.parkingDayConfigID,
      });
    }

    this.setState({
      'showModal': !this.state.showModal,
      'modalType': modalType,
    });
  }

  handleSelectDate = (fromDate, toDate, selectTypeDate) => {
    const { sort, pageSize } = this.state;
    const { match } = this.props;

    this.setState({
      fromDate,
      toDate,
      selectTypeDate,      
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
    });
    return this.props.dispatch(fetchGetParkingDayConfig(
      match.params.buildingID,
      'CUSTOM',   
      fromDate ? dateYYYYMMDD(fromDate) : null,
      toDate ? dateYYYYMMDD(toDate) : null,
      0,
      pageSize.value,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
    ));
  }

  handleCallback = (file) => {
    try {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { 'type':'binary' });
        const customParkingDayConfigWsName = wb.SheetNames[0];
        const customParkingDayConfigWs = wb.Sheets[customParkingDayConfigWsName];
        const customParkingDayConfigData = XLSX.utils.sheet_to_json(customParkingDayConfigWs);      
          
        this.setState({          
          'customDayConfigData' : customParkingDayConfigData,                    
        });
      };    
      reader.readAsBinaryString(file);
    } catch (error){
      this.setState({
        'error' : true,        
      });
    }
  }


  handleCustomData = () => {
    const customData = [];
    const { customDayConfigData } = this.state;    
    if (customDayConfigData.length > 0) {
      let startDateTime;
      let endDateTime;
      for (let customIndex = 0; customIndex < customDayConfigData.length; customIndex++) {
        if (customDayConfigData[customIndex].TIME_TYPE !== '' && customDayConfigData[customIndex].TIME_TYPE === 'CUSTOM') {
          startDateTime = customDayConfigData[customIndex].DATE !== '' && customDayConfigData[customIndex].START_TIME != '' ? `${customDayConfigData[customIndex].DATE} ${customDayConfigData[customIndex].START_TIME}:00` : null;
          endDateTime = customDayConfigData[customIndex].DATE !== '' && customDayConfigData[customIndex].END_TIME != '' ? `${customDayConfigData[customIndex].DATE} ${customDayConfigData[customIndex].END_TIME}:00` : null;
        } else if (customDayConfigData[customIndex].TIME_TYPE !== '' && customDayConfigData[customIndex].TIME_TYPE === 'ALL_DAY') {
          startDateTime = customDayConfigData[customIndex].DATE !== '' ? `${customDayConfigData[customIndex].DATE} 00:00:00` : null;
          endDateTime = customDayConfigData[customIndex].DATE !== '' ? `${customDayConfigData[customIndex].DATE} 23:59:00` : null;
        }
        
        const parkingZone = customDayConfigData[customIndex].PARKING_ZONE != '' ? customDayConfigData[customIndex].PARKING_ZONE : null;

        if (parkingZone && typeof parkingZone === String) {
          parseInt(parkingZone);
        }
     
        customData.push(
          {
            'buildingID' : this.props.match.params.buildingID,
            'parkingDayConfigID' : uuidv4(),
            'dayType': 'CUSTOM',          
            'parkingZone': parkingZone !== null ? `IN-${parkingZone < 9 ? `0${parkingZone}` : `${parkingZone}`}/OUT-${parkingZone < 9 ? `0${parkingZone}` : `${parkingZone}`}` : '',
            'allowance': customDayConfigData[customIndex].ALLOWANCE !== '' ? customDayConfigData[customIndex].ALLOWANCE : '',
            'chargeCustomer': customDayConfigData[customIndex].CHARGE_CUSTOMER !== '' ? customDayConfigData[customIndex].CHARGE_CUSTOMER : '',
            'startDatetime' : startDateTime,
            'endDatetime' : endDateTime,
          },
        );
      }
    }

    return customData;
  }

  handleUploadExcelCustomDayConfig = () => {
    this.setState({ 'loading' : true });
    this.props.dispatch(fetchCreateParkingDayConfig({ 'data' : this.handleCustomData() }));
  }

  handleUploadModalContent = () => <div className="upload-modal">
    <HeaderSection title={'Custom day config'} isHeader={true}/>
    <div className="custom-day-config-upload-input-container">
      <div className="custom-day-config-upload-label">Custom day config</div>
      <div className="custom-day-config-upload-input">
        <InputWithUpload
          id="tenant-componentDidMount"
          template="a"
          placeholder="Choose file to upload"
          callback={this.handleCallback}
          accept=".xlsx, .xls"                
        />
      </div>
    </div>
    <div className="custom-day-config-download-container">
      <div className="custom-day-config-download-label">Custom day config template</div>
      <div className="custom-day-config-download-button ">
        <div className="template-name">custom_day_config.xlsx</div>
        <div onClick={() => window.open(commonConstant.envCustomParkingDayConfigTemplate)} className="download-template-button">Download</div>
      </div>
    </div>
    <div className="custom-day-config-upload-button-container">
      <Button onClick={() => this.handleUploadExcelCustomDayConfig()} className="btn-primary send-data">ส่งข้อมูล</Button>
    </div>
  </div>


  render() {
    const { getParkingDayConfig } = this.props;
    const { pageSize, pageNumber, sort, showModal, selectTypeDate, fromDate, toDate, loading } = this.state;
    
    if (loading || !getParkingDayConfig.data) {
      return <Loading/>;
    }
    return (
      <div className="CustomDayConfig layout-box-page">
        <Modal 
          show={showModal}
          header={this.handleHeaderModal()}
          headerTemplate="a"
          handleToggle={this.handleShowModal}
        >
          {this.handleModalContent()}
        </Modal>
        <div onClick={() => history.push(commonConstant.pathSelectBuilding)} className="back-home-container">
          <div className="icon-container">
            <div className="icon fas fa-arrow-left" />
          </div>
          <div>กลับหน้าหลัก</div>
        </div>
        <div className="custom-day-config-header-container">
          <div className="calendar-filter-container">
            <div className="calendar-filter-label">ช่วงเวลา</div>
            <DatePicker id="filter-date" placeholder="เลือกช่วงเวลา" selectType={selectTypeDate} fromDate={fromDate}
              toDate={toDate} handleSelectDate={this.handleSelectDate} />
          </div>
          <div className="custom-day-config-button-container">
            <Button onClick={() => this.handleShowModal('upload')} className="btn-sixtary upload-button">              
              <img src={commonConstant.uploadImage}/>
              <div>Upload day config</div>
            </Button>
            <Button onClick={() => this.handleShowModal('create')} className="btn-primary create-button">
              <div className="icon icon-add"/>
              <div>สร้าง Custom day config</div>
            </Button>
          </div>
        </div>
        <div className="custom-day-config-table-container">
          <Table
            id="custom-parking-day-config-table"
            columnHeader={columnHeader}
            data={getParkingDayConfig.data.parkingDayConfig}
            passFuncBody={this.passFuncBody}
            pageSize={pageSize}
            pageNumber={pageNumber}
            maxData={validateToShowDash(totalParkingDayConfigRecords(getParkingDayConfig))}
            sort={sort}
            handlePageChange={this.handlePageChange}
            handleSort={this.handleSort}
            handlePageSize={this.handlePageSize}
            passFuncClick={{
              'view': item => this.handleShowModal('edit', item),
            }}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ 
  getParkingDayConfig,   
  updateParkingDayConfig,
  createParkingDayConfig,  
  getBuildingByRefNo,
}) => 
  ({ 
    getParkingDayConfig, 
    updateParkingDayConfig, 
    createParkingDayConfig,  
    getBuildingByRefNo,
  });

export default connect(mapStateToProps)(CustomDayConfig);

CustomDayConfig.propTypes = {
  'dispatch' : PropTypes.func,
  'match' : PropTypes.shape({
    'params' : PropTypes.shape({
      'buildingID' : PropTypes.string,
    }),
  }),
  'getParkingDayConfig' : PropTypes.shape({
    'status' : PropTypes.number,
    'type' : PropTypes.string,
    'data' : PropTypes.shape({
      'parkingDayConfig' : PropTypes.arrayOf({
        'dayType' : PropTypes.string,
        'parkingZone' : PropTypes.string,
        'allowance' : PropTypes.string,
        'chargeCustomer' : PropTypes.string,
        'startDatetime' : PropTypes.string,
        'endDatetime' : PropTypes.string,
        'parkingDayConfigID' : PropTypes.string,
      }),
    }),
  }),
  'updateParkingDayConfig' : PropTypes.shape({
    'status' : PropTypes.number,
    'type' : PropTypes.string,
  }),
  'createParkingDayConfig' : PropTypes.shape({
    'status' : PropTypes.number,
    'type' : PropTypes.string,
  }),
};
